import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { select, Store } from '@ngrx/store';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { GCI140Service } from '../../../../services/gci140.service';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { AppServicesLibraryService } from 'app-services-library';

@Component({
  selector: 'i140-pdf-view',
  templateUrl: './pdf-view.component.html',
  styleUrls: ['./pdf-view.component.scss']
})
export class PdfViewComponent implements OnInit, OnDestroy {

  letterType: string;
  documentTemplateId: string;
  disabledControls: boolean;
  pdfSrc: string;
  @Output()
  redirectionComponent: EventEmitter<string> = new EventEmitter<string>();

  observableSubscription$ = new Subject();
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;

  constructor(
    private store: Store<any>,
    private dynamicDialogConfig: DynamicDialogConfig,
    private gcI140Service: GCI140Service,
    private appServicesLibraryService: AppServicesLibraryService
    ) {
    this.disabledControls = false;
    this.pdfSrc = '';
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.documentTemplateId = sessionStorage.getItem('documentTemplateId');
    this.letterType = sessionStorage.getItem('typeOfLetter');
    // Get Specific step details by passing step code
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
      this.stepDetails = data;
      this.generatePDF();
      this.toggleControlsStatus();
    });
  }

  generatePDF() {
    this.gcI140Service.generatePDF(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, this.letterType, {
      templateId: parseInt(sessionStorage.getItem('documentTemplateId'))
    }).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      if (response) {
        let dataSlice = response.data['fileLocation'].split('/var/imagility/uploads/');
        this.pdfSrc = environment.docs + dataSlice[1];
      }
    });
  }

  //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" ||this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
  }

  backLink(){
    this.redirectionComponent.emit("LetterPreview");
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
}
